import firebase from 'firebase';

const firebaseConfigV2 = {
  apiKey: 'AIzaSyDuvIqf8STF8Ig_9FHd0QLCLmYT8ElG8TY',
  authDomain: 'kacarecos-c53a6.firebaseapp.com',
  projectId: 'kacarecos-c53a6',
  storageBucket: 'kacarecos-c53a6.appspot.com',
  messagingSenderId: '595543591307',
  appId: '1:595543591307:web:9ca338986c15f53940078e',
};

export const { FieldValue } = firebase.firestore;
export default firebase.initializeApp(firebaseConfigV2);
export const firebaseAnalytics = firebase.analytics();
